import { COUPONS_ROUTES } from '../../constants/_routes'
import couponsTypes from '../../constants/couponsTypes'
import { axios } from '../../services'
import { current_timestamp } from '../../helpers'

// INDEX
const coupons_index_request = () => {
  return {
    type: couponsTypes.index.request
  }
}

const coupons_index_success = (response) => {
  return {
    type: couponsTypes.index.success,
    payload: response.data
  }
}

const coupons_index_failure = (messages) => {
  return {
    type: couponsTypes.index.failure,
    payload: messages
  }
}

const coupons_index = (page=1, per_page=10, filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(coupons_index_request())

    // Request
    axios.get(
      COUPONS_ROUTES.index,
      {
        params: {
          page: page,
          per_page: per_page,
          sort: sort,
          order: order,
          filters: filters,
          serial: current_timestamp()
        }
      }
    ).then( response => {
      // success
      dispatch( coupons_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching coupons."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( coupons_index_failure(errors))
    })
  }

}

const coupons_select_success = (response) => {
  return {
    type: couponsTypes.index.select,
    payload: response.data
  }
}


const coupons_select = () => {
  return function (dispatch) {
    // Before Request
    dispatch(coupons_index_request())

    // Request
    axios.get(
      COUPONS_ROUTES.select
    ).then( response => {
      // success
      dispatch( coupons_select_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching coupons."]
      }
      dispatch( coupons_index_failure(errors))
    })
  }
}

export {
  coupons_index,
  coupons_select
}



// WEBPACK FOOTER //
// ./src/js/actions/coupons/getindex.js